import styled from 'styled-components';
import { CheggSVG } from '../svg'; // Typed this way to get around poor type inference
// For key values @see `IconSize` in ./types
// exported for tests and storybook

export var iconSizeToPixelValue = {
  xsmall: 16,
  small: 24,
  medium: 32,
  large: 48
}; // exported for testings

export var iconSizeToRemValue = {
  xsmall: 1,
  small: 1.5,
  medium: 2,
  large: 3
};
/**
 * Base Icon component
 *
 * Sized using `rem` units. Pixel equivalents in param info.
 *
 * Do not set height & width manually; use `size` instead.
 *
 * @param props.size xsmall: 16px, small (default): 24px, medium: 32px, large: 48px
 */

export var Icon = styled(CheggSVG).attrs(function (props) {
  var pixelValue = iconSizeToPixelValue[props.size ||
  /* istanbul ignore next */
  'small'];
  return {
    height: pixelValue,
    width: pixelValue
  };
}).withConfig({
  displayName: "icon__Icon",
  componentId: "sc-18q4eit-0"
})(["", ""], function (props) {
  var remValue = iconSizeToRemValue[props.size ||
  /* istanbul ignore next */
  'small'];
  return "\n      height: ".concat(remValue, "rem;\n      width: ").concat(remValue, "rem;\n      // without setting min-values, the icons can shrink below desired size when used in flexbox\n      min-height: ").concat(remValue, "rem;\n      min-width: ").concat(remValue, "rem;\n    ");
});
Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: 'small',
  viewBox: '0 0 48 48'
};
export * from './types';